const parseAmount = (value) => (value ? value.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&'") : value);

export default parseAmount;
